import { connect } from "react-redux";
import { get } from "lodash";
import Imprint from "../../components/pages/Imprint";

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = state => {
  return {
    branding: get(state, "branding")
  };
};

export default connect(mapStateToProps)(Imprint);
